<template>
  <v-card
    v-if="show"
    class="debug-panel mx-10 px-10"
  >
    <p class="text-h5 mt-5">Input Editor
      <v-btn
        class="remove-btn-effect  ml-5"
        dark
        color="cyan"
        @click="showDebugContent = !showDebugContent"
      >
        Show / Hide
      </v-btn>
      <v-btn
        class="remove-btn-effect ml-5"
        dark
        color="success"
        @click="updateConfig"
      >
        Update Inputs
      </v-btn>
      <span class="ml-5">{{debugDescription}}</span>
    </p>
    <div
      v-if="showDebugContent"
      class="debug-panel-content"
    >

      <v-textarea
        class="debug-panel-input"
        height="350"
        outlined
        v-model="inputConfigsString"
      >
      </v-textarea>
    </div>
  </v-card>
</template>

<style scoped>
  .debug-panel{
    max-height: 40vh;
    max-width: 100vw;
    width: 97%;
    position: fixed;
    bottom: 0;
    left:0;
  }
  .mt-3rem{
    margin-top: 3rem;
  }
  .mb-5rem{
    margin-bottom: 5rem;
  }
  .font-class{
    white-space: nowrap;
    text-align: left;
    font-family: Source Han Sans HK;
    font-style: normal;
  }
  .home-moving-title{
    font-weight: bold;
    font-size: 45px;
    color: rgba(54,77,137,1);
  }
</style>
<script>
export default {
  name: 'FormEditor',
  props: {
    show: {
      default: true,
      type: Boolean
    },
    inputConfigs: {
      default () {
        return [
          {
            md: 12,
            sm: 12,
            sectionTitle: '聯絡資料 Information'
          },
          {
            md: 4,
            sm: 12,
            offsetRightMd: 8,
            propName: 'clientName',
            toplabel: '姓名 Name',
            type: {
              required: true
            }
          }]
      },
      type: Array
    }
  },
  data () {
    return {
      showDebugContent: true,
      debugDescription: '',
      inputConfigsString: ''
    }
  },
  mounted () {
    this.inputConfigsString = JSON.stringify(this.inputConfigs, null, 4)
  },
  methods: {
    updateConfig (e) {
      try {
        this.debugDescription = ''
        const updateConfig = JSON.parse(this.inputConfigsString)
        console.log('updateConfig', updateConfig)
        this.$emit('update', updateConfig)
      } catch (ex) {
        console.log('updateConfig ex', ex)
        this.debugDescription = ex
      }
    }
  }
}
</script>
